import { render, staticRenderFns } from "./LoadingButtonIcon.vue?vue&type=template&id=3b18ff8b&"
import script from "./LoadingButtonIcon.vue?vue&type=script&lang=js&"
export * from "./LoadingButtonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports